import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';
import { FileLibrary } from '../../stores/libraries/FileLibrary';

interface IFileDropZoneUploadingItemProgress
{
	/** Внутренний Идентификатор добавленного файла */
	FileId: string,

	/** Идентификатор типа файлов, который привязан к текущему списку загружаемых файлов */
	FileTypeId: string
}

export const FileDropZoneUploadingItemProgress: React.FC<IFileDropZoneUploadingItemProgress> = observer(
	(
		{ FileId, FileTypeId }: IFileDropZoneUploadingItemProgress
	) =>
	{
		const { uiState } = useStores();
		const store = uiState.files;

		let fs: FileLibrary = store.findFileInList(FileTypeId, FileId);

		React.useEffect(() =>
		{
			fs.FileUpload();
		}, [fs, fs.Percent])

		return (
			<>
				<div className="in-progress__progressbar">
					<div className="in-progress__progressbar-full"></div>
					<div className="in-progress__progressbar-complete" style={{ width: "" + Math.round(fs.Percent) + "%" }}></div>
				</div>
				<div className="in-progress__percents f-14">{Math.round(fs.Percent)}%</div>
			</>
		);
	}
)